import filterAssembler from './map/filter_assembler'
import mapConverters from './map/map_converters'

function Filter(parsedFilter, locationFields) {

  this.modified = false;
  this._data = parsedFilter;
  this._locationFields = locationFields;

}

// returns an array containing the expressions from exA that are not present in exB
Filter.expressionsRemoved = function(exA, exB) {
  return this.expressionsAdded(exB, exA);
};

// returns an array containing the expressions from exB that are not present in exA
Filter.expressionsAdded = function(exA, exB) {
  var exC = [];

  exB.forEach(function(expressionB, indexB) {
    var match = false;
    exA.forEach(function(expressionA) {
      if(expressionB.field === expressionA.field){
        if(expressionB.value.sort().toString().replace(/'/g, '') === expressionA.value.sort().toString().replace(/'/g, '')) {
          match = true;
        }
      }
    });
    if(!match){
      exC.push(expressionB);
    }
  });

  return exC;
};

Filter.prototype = {
  constructor: Filter,

  setData: function(newData) {
    if(newData !== this._data){
      this._data = newData;
      this.modified = true;
    }
  },

  expressions: function() {
    return this._data;
  },

  shapes: function() {
    return this._data.filter(function(element){
      return ( element.type === "shape" && element.function_name !== null );
    });
  },

  overlays: function() {
    return this._data.filter(function(element){
      return element.field === "MapOverlay";
    });
  },

  locations: function() {
    var self = this;
    return this._data.filter(function(element){
      return self._locationFields.indexOf(element.field) > -1;
    });    
  },

  addPolygon: function(pointsArray) {

    const pointsString = mapConverters.getStringFromPoints(pointsArray);
    
    let expression = {
      block_group: 0,
      level: 0,
      condition: "polygon('" + pointsString + "')",
      conjunction: "And",
      field: 'Location',
      function_name: 'polygon',
      function_parameters: [ pointsString ],
      operator: 'Eq',
      type: 'shape',
      unary_operator: null,
      value: [{
       type: 'LineString',
       coordinates: []
      }]
    }

    pointsArray.forEach((latLng) => {
      expression.value[0].coordinates.push([latLng.lat(), latLng.lng()]);
    });

    this._data.push(expression);
      
    this.modified = true;
  },

  toString: function(){
    return filterAssembler(this._data);
  },

  removeShapes: function() {
    var self = this;

    var shapeRemoved = false;

    this._data.forEach(function(element, index, dataArray){
      if(element.type === 'shape'){
        dataArray.splice(index, 1);
        self.modified = true;
        shapeRemoved = true;
      }
    });

  },

  propertyType: function() {
    var propertyTypes = [];

    this._data.forEach(function(element, index, dataArray){
      if(element.field === 'PropertyType'){
        element.value.forEach((value) => {
          propertyTypes.push(value.replace(/'/g, ''));
        })
      }
    });

    return propertyTypes;
  },

  propertyClass: function() {
    var propertyClasses = [];

    this._data.forEach(function(element, index, dataArray){
      if(element.field === 'PropertyClass'){
        element.value.forEach((value) => {
          propertyClasses.push(value.replace(/'/g, ''));
        })
      }
    });

    return propertyClasses;
  }

};

export default Filter;
